import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EmitentesListPage from './pages/EmitentesListPage';
import EmitenteEditPage from './pages/EmitenteEditPage';
import EmpresaHubPage from './pages/EmpresaHubPage';
import EmpresaPainelPage from './pages/EmpresaPainelPage';
import PessoasListPage from './pages/PessoasListPage';
import PessoaEditPage from './pages/PessoaEditPage';
import ProdutosListPage from './pages/ProdutosListPage';
import VeiculosListPage from './pages/VeiculosListPage';
import VeiculoEditPage from './pages/VeiculoEditPage';
import AuditoriaPage from './pages/AuditoriaPage';
import DevolucaoPage from './pages/DevolucaoPage';
import ProdutoEditPage from './pages/ProdutoEditPage';
import DocumentosRedirect from './pages/DocumentosRedirect';
import RascunhoEditPage from './pages/RascunhoEditPage';
import ConfiguracoesPage from './pages/ConfiguracoesPage';
import InutilizacoesPage from './pages/InutilizacoesPage';
import DFePage from './pages/DFePage';
import PendenciasPage from './pages/PendenciasPage';
import ImportacoesXmlPage from './pages/ImportacoesXmlPage';
import RelatoriosPage from './pages/RelatoriosPage';
import ComprasPage from './pages/ComprasPage';
import AppShell from './components/AppShell';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />

        {/* Gerenciar empresas */}
        <Route path="/emitentes" element={<EmitentesListPage />} />
        <Route path="/emitentes/novo" element={<EmitenteEditPage />} />
        <Route path="/emitentes/:id" element={<Navigate to="/empresa/:id" replace />} />

        {/* Hub e Painéis por empresa */}
        <Route path="/empresa/:id" element={<EmpresaHubPage />} />
        <Route path="/empresa/:id/hub" element={<EmpresaHubPage />} />
        <Route path="/empresa/:id/editar" element={<EmitenteEditPage />} />
        <Route path="/empresa/:id/painel/:tipo" element={<EmpresaPainelPage />} />

        {/* Listas globais / cadastros unificados */}
        <Route path="/pessoas" element={<PessoasListPage />} />
        <Route path="/pessoas/novo" element={<PessoaEditPage />} />
        <Route path="/pessoas/:id" element={<PessoaEditPage />} />
        <Route path="/produtos" element={<ProdutosListPage />} />
        <Route path="/produtos/novo" element={<ProdutoEditPage />} />
        <Route path="/produtos/:id" element={<ProdutoEditPage />} />
        <Route path="/veiculos" element={<VeiculosListPage />} />
        <Route path="/veiculos/novo" element={<VeiculoEditPage />} />
        <Route path="/veiculos/:id" element={<VeiculoEditPage />} />
        <Route path="/auditoria" element={<AuditoriaPage />} />
        <Route path="/nfe/devolucao" element={<DevolucaoPage />} />
        <Route path="/documentos" element={<DocumentosRedirect />} />
        <Route path="/documentos/:tipo/novo" element={<RascunhoEditPage />} />
        <Route path="/documentos/:tipo/:id" element={<RascunhoEditPage />} />

        <Route path="/inutilizacoes" element={<InutilizacoesPage />} />
        <Route path="/dfe" element={<DFePage />} />
        <Route path="/compras" element={<ComprasPage />} />
        <Route path="/importacoes/xml" element={<ImportacoesXmlPage />} />
        <Route path="/pendencias" element={<PendenciasPage />} />
        <Route path="/relatorios" element={<RelatoriosPage />} />
        <Route path="/configuracoes" element={<ConfiguracoesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
